// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import Description from './view'

export default function DescriptionFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/Description">
      <Description {...props}>
        {children}
      </Description>
    </Flow>
  )
}
